import { render, staticRenderFns } from "./baseData.vue?vue&type=template&id=76c9f42f&scoped=true"
import script from "./baseData.vue?vue&type=script&lang=js"
export * from "./baseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c9f42f",
  null
  
)

export default component.exports